mutation Inertia_UpdateParticipant($participantId: ID!, $name: String!) {
  updateParticipant(input: { participantId: $participantId, name: $name }) {
    participant {
      id
      name
    }
    errors
  }
}